import * as Yup from 'yup'

const cmsHomepageSectionEditScheme = Yup.object().shape({
  name            : Yup.string().required('Required'),
  title_text      : Yup.string().required('Required'),
  order           : Yup.number().required('Required'),
  alt_text        : Yup.string().required('Required'),
  is_active       : Yup.boolean().required('Required'),
  platform        : Yup.string().required('Required'),
  seo_title       : Yup.string(),
  header_text     : Yup.string(),
  caption_text    : Yup.string(),
  url             : Yup.string(),
  landscape_image : Yup.mixed()
    .test(
      [ 'landscape_image' ],
      'Image files only. (*.jpeg or *.png)',
      (value) => {
        if (!value) return true
        else return (value && [ 'image/png', 'image/jpeg' ].includes(value.type))
      }
    ),
  portrait_image: Yup.mixed()
    .test(
      [ 'portrait_image' ],
      'Image files only. (*.jpeg or *.png)',
      (value) => {
        if (!value) return true
        else return (value && [ 'image/png', 'image/jpeg' ].includes(value.type))
      }
    )
})

export default cmsHomepageSectionEditScheme
